var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.3 56.648 40.388 60.008 26.34 62.796 29.301 54.298 19.545 52.131 26.028 45.637 31.655 37 33.953 40.312 39.17 54.604"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.415 36.947 94.537 39.661 93.29 38.749 88.153 40.848 86.374 42.373 84.445 41.623 79.272 46.733 74.424 41.72 77.743 38.251 72.317 36.069 70.668 34.381 65.004 34.448 57.889 38.571 58.532 41.734 52.999 46.924 48.803 50.188 49.852 55.611 55.151 56.697 51.654 59.571 51.816 62.574 40.068 70.277 35.462 76.73 35.489 83.7 42.67 83.434 47.022 77.844 52.894 75.415 56 80 58 74 61.084 77.58 65.316 84.129 68 82 74.657 85.515 76.945 84.664 76.555 96.314 68.206 97.996 64.502 96.545 60.614 99.019 53.714 95.291 51.714 91.227 46.709 91.406 42.806 92.787 37.91 94.084 34 93 30 100"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45 13 48.026 21.992 50.861 25.64 60.27 20.39 60.378 17.705 65.062 10.593"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldGlobe);
export default __webpack_public_path__ + "static/media/world-globe.f054e550bd173e69e608528835192cb3.svg";
export { ForwardRef as ReactComponent };